module.exports = __webpack_public_path__ + "img/12_51.bc47bc18.png";